import type { FlightsTranslations } from "@/service/translate/flights/flightTranslations.types"

const flightsFrTranslations: FlightsTranslations = {
    "flightPage": {
        "title": "Avion",
        "step": "Étape",
        "resultsFound": "Vol dénichées par nos experts"
    },
    "flightSortBy": {
        title: "Trier par",
        price_asc: "Prix le plus bas",
        price_desc: "Prix le plus élevé",
        fastest: "Le plus rapide",
        long_stay: "Plus de temps de ski"
    },
    "flightBlock": {
        "title": "Titre du bloc de vol",
        "direct": "Direct"
    },
    "flightFilters": {
        "outboundTrip": {
            "title": "Heures de vol sortantes",
            "duration": "Duration",
            "departure": {
                "location": "Aéroport de départ",
                "time": "Départ"
            },
            "arrival": {
                "location": "Aéroport de destination",
                "time": "Arrivée"
            }
        },
        "inboundTrip": {
            "title": "Heures de vol entrantes",
            "duration": "Duration",
            "departure": {
                "location": "",
                "time": "Départ"
            },
            "arrival": {
                "location": "",
                "time": "Arrivée"
            }
        },
        "duration": "Durée du vol",
        "airlines": "Compagnie"
    },
    "airportsNames": {
        "ABZ": "Aberdeen",
        "ACI": "Alderney",
        "BFS": "Belfast International",
        "BHD": "George Best Belfast City",
        "BHX": "Birmingham",
        "BOH": "Bournemouth",
        "BRS": "Bristol",
        "CWL": "Cardiff",
        "CEG": "Chester Hawarden",
        "LDY": "City of Derry",
        "CAX": "Carlisle Lake District",
        "DSA": "Doncaster Sheffield",
        "DND": "Dundee",
        "EMA": "East Midlands",
        "EDI": "Edinburgh",
        "EXT": "Exeter",
        "GCI": "Guernsey",
        "GLA": "Glasgow",
        "PIK": "Glasgow Prestwick",
        "HUY": "Humberside",
        "INV": "Inverness",
        "IOM": "Isle of Man",
        "JER": "Jersey",
        "LBA": "Leeds Bradford",
        "LPL": "Liverpool John Lennon",
        "LCY": "London City",
        "LGW": "London Gatwick",
        "LHR": "London Heathrow",
        "LTN": "London Luton",
        "SEN": "London Southend",
        "STN": "London Stansted",
        "MAN": "Manchester",
        "NCL": "Newcastle International",
        "NQY": "Newquay",
        "NWI": "Norwich",
        "SOU": "Southampton",
        "MME": "Teesside International",
        "LYS": "Lyon-Saint-Exupéry",
        "GNB": "Grenoble Alpes Isère",
        "GVA": "Genève-Cointrin",
        "CMF": "Chambéry-Savoie",
        "MFL": "Aéroport de Mount Full Stop",
        "TRN": "Turin-Caselle",
        "SNN": "Shannon",
        "ORK": "Cork",
        "NOC": "Ireland West Knock"
    },
    "airlinesNames": {
        "U2": "easyJet",
        "LS": "Jet2.com",
        "BA": "British Airways",
        "BY": "TUI Airways",
        "LX": "Swiss International Air Lines",
        "AF": "Air France",
        "V7": "Volotea",
        "LH": "Lufthansa",
        "KL": "KLM Royal Dutch Airlines",
        "IB": "Iberia",
        "W9": "Wizz Air",
        "EI": "Aer Lingus",
        "FR": "Ryanair",
        "WW": "WOW air",
    }
}

export default flightsFrTranslations;